import Vue from "vue";
import { MutationTree } from "vuex";
import { StageConfigState } from "./types";

export const mutations: MutationTree<StageConfigState> = {
  setConfig: (state, { data }: { data: StageConfigState }) => {
    state.auth0Domain = data.auth0Domain;
    state.auth0ClientId = data.auth0ClientId;
    state.auth0Audience = data.auth0Audience;
    state.auth0RedirectUri = data.auth0RedirectUri;
    state.exchangeAPIUrl = data.exchangeAPIUrl;
    state.stage = data.stage;
    state.graphqlBase = data.graphqlBase;
    state.renderBase = data.renderBase;
    state.profileUrl = data.profileUrl;
    state.appURL = data.appURL;
    state.features = data.features;
  }
};
